var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplayDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 60,
    viewBox: "0 0 204 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 0.5,
    width: 201.5,
    height: 59,
    rx: 4.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.954 32.6268C99.4255 32.6268 96.55 35.3103 96.55 39.0063C96.55 42.6798 99.4255 45.3858 102.954 45.3858C106.483 45.3858 109.358 42.6798 109.358 39.0063C109.357 35.3103 106.482 32.6268 102.954 32.6268ZM102.954 42.8748C101.02 42.8748 99.3535 41.2803 99.3535 39.0078C99.3535 36.7113 101.022 35.1408 102.954 35.1408C104.887 35.1408 106.554 36.7113 106.554 39.0078C106.554 41.2788 104.887 42.8748 102.954 42.8748ZM88.9825 32.6268C85.4545 32.6268 82.579 35.3103 82.579 39.0063C82.579 42.6798 85.4545 45.3858 88.9825 45.3858C92.512 45.3858 95.3875 42.6798 95.3875 39.0063C95.3875 35.3103 92.512 32.6268 88.9825 32.6268ZM88.9825 42.8748C87.049 42.8748 85.3825 41.2803 85.3825 39.0078C85.3825 36.7113 87.0505 35.1408 88.9825 35.1408C90.916 35.1408 92.5825 36.7113 92.5825 39.0078C92.584 41.2788 90.916 42.8748 88.9825 42.8748ZM72.3655 34.5858V37.2918H78.8425C78.649 38.8143 78.142 39.9258 77.368 40.6983C76.426 41.6403 74.9515 42.6798 72.3655 42.6798C68.3785 42.6798 65.2615 39.4653 65.2615 35.4783C65.2615 31.4913 68.3785 28.2768 72.3655 28.2768C74.5165 28.2768 76.087 29.1228 77.2465 30.2103L79.156 28.3008C77.536 26.7543 75.3865 25.5708 72.3655 25.5708C66.904 25.5708 62.3125 30.0168 62.3125 35.4783C62.3125 40.9398 66.904 45.3858 72.3655 45.3858C75.313 45.3858 77.5375 44.4183 79.276 42.6063C81.064 40.8183 81.6205 38.3043 81.6205 36.2748C81.6205 35.6478 81.5725 35.0673 81.475 34.5843H72.3655V34.5858ZM140.327 36.6873C139.797 35.2623 138.177 32.6268 134.866 32.6268C131.58 32.6268 128.848 35.2128 128.848 39.0063C128.848 42.5823 131.556 45.3858 135.18 45.3858C138.103 45.3858 139.795 43.5978 140.497 42.5583L138.322 41.1078C137.597 42.1713 136.606 42.8718 135.18 42.8718C133.755 42.8718 132.739 42.2193 132.087 40.9383L140.617 37.4103L140.327 36.6873ZM131.628 38.8143C131.555 36.3483 133.537 35.0928 134.964 35.0928C136.075 35.0928 137.017 35.6493 137.332 36.4458L131.628 38.8143ZM124.693 45.0003H127.495V26.2488H124.693V45.0003ZM120.1 34.0533H120.004C119.375 33.3033 118.167 32.6268 116.646 32.6268C113.455 32.6268 110.532 35.4303 110.532 39.0318C110.532 42.6078 113.455 45.3873 116.646 45.3873C118.168 45.3873 119.375 44.7108 120.004 43.9383H120.1V44.8563C120.1 47.2968 118.795 48.6018 116.693 48.6018C114.977 48.6018 113.914 47.3703 113.479 46.3308L111.039 47.3463C111.739 49.0368 113.599 51.1158 116.693 51.1158C119.98 51.1158 122.759 49.1823 122.759 44.4693V33.0153H120.102V34.0533H120.1ZM116.887 42.8748C114.954 42.8748 113.335 41.2548 113.335 39.0318C113.335 36.7833 114.954 35.1408 116.887 35.1408C118.795 35.1408 120.293 36.7833 120.293 39.0318C120.293 41.2548 118.795 42.8748 116.887 42.8748ZM153.458 26.2488H146.752V45.0003H149.549V37.8963H153.457C156.559 37.8963 159.61 35.6508 159.61 32.0733C159.61 28.4958 156.561 26.2488 153.458 26.2488ZM153.53 35.2863H149.549V28.8588H153.53C155.623 28.8588 156.811 30.5913 156.811 32.0733C156.811 33.5253 155.623 35.2863 153.53 35.2863ZM170.829 32.5938C168.802 32.5938 166.703 33.4863 165.835 35.4648L168.319 36.5013C168.85 35.4648 169.84 35.1258 170.876 35.1258C172.324 35.1258 173.795 35.9943 173.819 37.5378V37.7313C173.312 37.4418 172.226 37.0083 170.9 37.0083C168.223 37.0083 165.496 38.4798 165.496 41.2293C165.496 43.7388 167.692 45.3543 170.152 45.3543C172.033 45.3543 173.071 44.5098 173.722 43.5198H173.818V44.9673H176.521V37.7778C176.522 34.4508 174.035 32.5938 170.829 32.5938ZM170.49 42.8703C169.575 42.8703 168.295 42.4113 168.295 41.2773C168.295 39.8298 169.888 39.2748 171.264 39.2748C172.492 39.2748 173.072 39.5403 173.819 39.9018C173.602 41.6403 172.107 42.8703 170.49 42.8703ZM186.364 33.0033L183.156 41.1333H183.059L179.73 33.0033H176.714L181.708 44.3658L178.861 50.6868H181.78L189.476 33.0033H186.364ZM161.155 45.0003H163.952V26.2488H161.155V45.0003Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8763 15.3643C71.8763 16.6213 71.5043 17.6218 70.7588 18.3688C69.9128 19.2568 68.8088 19.7008 67.4528 19.7008C66.1538 19.7008 65.0483 19.2508 64.1408 18.3508C63.2318 17.4493 62.7773 16.3333 62.7773 15.0013C62.7773 13.6678 63.2318 12.5518 64.1408 11.6518C65.0483 10.7503 66.1538 10.3003 67.4528 10.3003C68.0978 10.3003 68.7143 10.4263 69.2993 10.6768C69.8858 10.9288 70.3553 11.2633 70.7063 11.6818L69.9158 12.4738C69.3203 11.7613 68.4998 11.4058 67.4513 11.4058C66.5033 11.4058 65.6843 11.7388 64.9928 12.4048C64.3013 13.0708 63.9563 13.9363 63.9563 14.9998C63.9563 16.0633 64.3013 16.9288 64.9928 17.5948C65.6843 18.2608 66.5033 18.5938 67.4513 18.5938C68.4563 18.5938 69.2948 18.2593 69.9653 17.5888C70.4003 17.1523 70.6523 16.5448 70.7198 15.7663H67.4513V14.6848H71.8118C71.8568 14.9203 71.8763 15.1468 71.8763 15.3643Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7915 11.6054H74.6935V14.4584H78.3895V15.5399H74.6935V18.3929H78.7915V19.4999H73.537V10.4999H78.7915V11.6054Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6678 19.4999H82.5113V11.6054H79.9973V10.4999H86.1818V11.6054H83.6678V19.4999Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6563 19.4999V10.4999H91.8127V19.4999H90.6563Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9415 19.4999H95.785V11.6054H93.271V10.4999H99.4555V11.6054H96.9415V19.4999Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.163 18.3374C110.278 19.2464 109.178 19.7009 107.863 19.7009C106.547 19.7009 105.448 19.2464 104.564 18.3374C103.679 17.4284 103.238 16.3154 103.238 14.9999C103.238 13.6844 103.679 12.5714 104.564 11.6624C105.448 10.7534 106.547 10.2974 107.863 10.2974C109.171 10.2974 110.269 10.7549 111.157 11.6684C112.045 12.5819 112.489 13.6919 112.489 14.9999C112.489 16.3154 112.046 17.4284 111.163 18.3374ZM105.418 17.5829C106.084 18.2579 106.898 18.5939 107.863 18.5939C108.827 18.5939 109.643 18.2564 110.308 17.5829C110.974 16.9079 111.308 16.0469 111.308 14.9999C111.308 13.9529 110.974 13.0919 110.308 12.4169C109.643 11.7419 108.827 11.4059 107.863 11.4059C106.898 11.4059 106.084 11.7434 105.418 12.4169C104.753 13.0919 104.419 13.9529 104.419 14.9999C104.419 16.0469 104.753 16.9079 105.418 17.5829Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.112 19.4999V10.4999H115.519L119.893 17.5004H119.942L119.893 15.7664V10.4999H121.049V19.4999H119.842L115.265 12.1589H115.216L115.265 13.8929V19.4999H114.112Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8763 15.3643C71.8763 16.6213 71.5043 17.6218 70.7588 18.3688C69.9128 19.2568 68.8088 19.7008 67.4528 19.7008C66.1538 19.7008 65.0483 19.2508 64.1408 18.3508C63.2318 17.4493 62.7773 16.3333 62.7773 15.0013C62.7773 13.6678 63.2318 12.5518 64.1408 11.6518C65.0483 10.7503 66.1538 10.3003 67.4528 10.3003C68.0978 10.3003 68.7143 10.4263 69.2993 10.6768C69.8858 10.9288 70.3553 11.2633 70.7063 11.6818L69.9158 12.4738C69.3203 11.7613 68.4998 11.4058 67.4513 11.4058C66.5033 11.4058 65.6843 11.7388 64.9928 12.4048C64.3013 13.0708 63.9563 13.9363 63.9563 14.9998C63.9563 16.0633 64.3013 16.9288 64.9928 17.5948C65.6843 18.2608 66.5033 18.5938 67.4513 18.5938C68.4563 18.5938 69.2948 18.2593 69.9653 17.5888C70.4003 17.1523 70.6523 16.5448 70.7198 15.7663H67.4513V14.6848H71.8118C71.8568 14.9203 71.8763 15.1468 71.8763 15.3643Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7915 11.6054H74.6935V14.4584H78.3895V15.5399H74.6935V18.3929H78.7915V19.4999H73.537V10.4999H78.7915V11.6054Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6678 19.4999H82.5113V11.6054H79.9973V10.4999H86.1818V11.6054H83.6678V19.4999Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6563 19.4999V10.4999H91.8127V19.4999H90.6563Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9415 19.4999H95.785V11.6054H93.271V10.4999H99.4555V11.6054H96.9415V19.4999Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.163 18.3374C110.278 19.2464 109.178 19.7009 107.863 19.7009C106.547 19.7009 105.448 19.2464 104.564 18.3374C103.679 17.4284 103.238 16.3154 103.238 14.9999C103.238 13.6844 103.679 12.5714 104.564 11.6624C105.448 10.7534 106.547 10.2974 107.863 10.2974C109.171 10.2974 110.269 10.7549 111.157 11.6684C112.045 12.5819 112.489 13.6919 112.489 14.9999C112.489 16.3154 112.046 17.4284 111.163 18.3374ZM105.418 17.5829C106.084 18.2579 106.898 18.5939 107.863 18.5939C108.827 18.5939 109.643 18.2564 110.308 17.5829C110.974 16.9079 111.308 16.0469 111.308 14.9999C111.308 13.9529 110.974 13.0919 110.308 12.4169C109.643 11.7419 108.827 11.4059 107.863 11.4059C106.898 11.4059 106.084 11.7434 105.418 12.4169C104.753 13.0919 104.419 13.9529 104.419 14.9999C104.419 16.0469 104.753 16.9079 105.418 17.5829Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M114.112 19.4999V10.4999H115.519L119.893 17.5004H119.942L119.893 15.7664V10.4999H121.049V19.4999H119.842L115.265 12.1589H115.216L115.265 13.8929V19.4999H114.112Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_3247_10109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4035 11.307C15.967 11.769 15.709 12.486 15.709 13.4145V46.5885C15.709 47.5185 15.967 48.234 16.4035 48.696L16.5145 48.804L35.098 30.2205V30.0015V29.7825L16.5145 11.1975L16.4035 11.307Z",
    fill: "url(#paint0_linear_3247_10109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2912 36.4171L35.0977 30.2206V30.0016V29.7826L41.2927 23.5876L41.4322 23.6671L48.7717 27.8371C50.8672 29.0281 50.8672 30.9766 48.7717 32.1691L41.4322 36.3391L41.2912 36.4171Z",
    fill: "url(#paint1_linear_3247_10109)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3247_10109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4333 36.3375L35.0973 30.0015L16.4043 48.696C17.0943 49.428 18.2358 49.518 19.5213 48.789L41.4333 36.3375Z",
    fill: "url(#paint2_linear_3247_10109)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.4333 23.6655L19.5213 11.2155C18.2358 10.485 17.0943 10.5765 16.4043 11.3085L35.0988 30.003L41.4333 23.6655Z",
    fill: "url(#paint3_linear_3247_10109)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 0.5,
    width: 201.5,
    height: 59,
    rx: 4.5,
    stroke: "#A6A6A6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_3247_10109",
    x: 15.709,
    y: 10.7114,
    width: 34.6348,
    height: 38.5811,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3247_10109"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3247_10109",
    result: "effect2_innerShadow_3247_10109"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3247_10109",
    x: 16.4043,
    y: 30.0015,
    width: 25.0293,
    height: 19.291,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3247_10109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3247_10109",
    x1: 33.4507,
    y1: 13.0635,
    x2: 8.27769,
    y2: 38.2365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3247_10109",
    x1: 51.4994,
    y1: 30.0016,
    x2: 15.2056,
    y2: 30.0016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3247_10109",
    x1: 37.9924,
    y1: 33.4423,
    x2: 3.8547,
    y2: 67.5801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3247_10109",
    x1: 11.6964,
    y1: 0.26524,
    x2: 26.9398,
    y2: 15.5087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplayDownload);
export default __webpack_public_path__ + "static/media/googleplay-download.33d3616ee1ad1e0bfcbbf9469a827ffb.svg";
export { ForwardRef as ReactComponent };